import template from './trip-change-eurail-ticket.html';
import changeTicketModalTemplate from './trip-change-eurail-ticket-modal.html';
import changeTicketNotEligibleModal from './trip-change-eurail-ticket-not-eligible.html';

const DIRECTIVE_NAME = TripChangeEuRailTicket.DIRECTIVE_NAME = 'ktTripChangeEurailTicket';
export default function TripChangeEuRailTicket() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripChangeEuRailTicketController,
        controllerAs: '$ctrl',
        scope: {
            railRecommendation: `=${DIRECTIVE_NAME}`,
            trip: `=${DIRECTIVE_NAME}Trip`,
            travellersCount: `=${DIRECTIVE_NAME}TravellersCount`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripChangeEuRailTicketController(
    $scope,
    $rootScope,
    userService,
    modalService,
    railAmendmentService,
    tripItemService,
    tripChangeEuRailTicketService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        navigateToSearchForm,
        checkJourneyChangeEligibility,
        continueButtonDisabled,
        moment,
    });

    function $onInit() {
        vm.readOnlyMode = $rootScope.readOnlyMode;
        vm.isItemCanBeAmended = !vm.trip.ApprovalSettings.IsApprovalRequired && !tripItemService.itemCannotBeAmended(vm.railRecommendation, vm.trip);
        vm.regionalSettings = userService.getRegionalSettings();
    }

    function checkJourneyChangeEligibility() {
        railAmendmentService.getEuRailsJourneyChangeables(vm.railRecommendation.Id, vm.trip.Id)
            .then((data) => {
                vm.changeables = data;
                return data.length > 0 ? openChangeTicketModal() : openChangeTicketUnavailabilityModal();
            });
    }

    function openChangeTicketModal() {
        modalService.openModal({
            template: changeTicketModalTemplate,
            scope: $scope,
        });
    }

    function openChangeTicketUnavailabilityModal() {
        modalService.openModal({
            template: changeTicketNotEligibleModal,
            scope: $scope,
        });
    }

    function continueButtonDisabled() {
        return vm.form.$invalid;
    }

    function navigateToSearchForm() {
        vm.form.$setSubmitted();
        if (vm.form.$invalid) {
            return;
        }

        const {selectedChangeable, railRecommendation, travellersCount} = vm;
        const tripId = vm.trip.Id;
        const params = {
            selectedChangeable,
            railRecommendation,
            tripId,
            groupTicketsPrice: 0.0,
            travellersCount,
        };
        tripChangeEuRailTicketService.navigateToSearchForm(params);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-eurail-ticket/trip-change-eurail-ticket-component.js